document.addEventListener('DOMContentLoaded', async function () {
    const form = document.getElementById('filmflix-plus-competition-form');

    if (!form) {
        return;
    }

    const statusCheckbox = form.querySelector('[name="status"]');
    const notificationsCheckbox = form.querySelector('[name="notifications_enabled"]');

    if (!statusCheckbox || !notificationsCheckbox) {
        return;
    }

    const endpoint = `${window.location.origin}/admin/filmflix-plus/competitions/template/start-status`;

    try {
        const response = await fetch(endpoint, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
            },
        });

        if (!response.ok) {
            return;
        }

        const data = await response.json();

        if (data.ready || !data.message) {
            return;
        }

        const alert = document.createElement('div');
        alert.className = 'alert alert-warning filmflix-plus-template-warning';
        alert.textContent = data.message;

        form.parentNode.insertBefore(alert, form);

        function updateWarningVisibility() {
            alert.classList.toggle(
                'd-none',
                !(statusCheckbox.checked && notificationsCheckbox.checked)
            );
        }

        statusCheckbox.addEventListener('change', updateWarningVisibility);
        notificationsCheckbox.addEventListener('change', updateWarningVisibility);
        updateWarningVisibility();
    } catch (error) {
        console.error(error);
    }
});
